export const  getBaseRoute = (path) => {
  path = path.replace(/\/$/, "");
  const parts = path.split("/").filter((part) => part);
  if (parts.length > 0) {
    return `/${parts[0]}`;
  }

  return "/";
}